<template>
  <el-dialog title="修改资料" :visible.sync="formVisible" :close-on-click-modal="false">
    <el-col :span="24" style="margin-bottom: 20px;">
      <el-form :model="formData" label-width="80px" :rules="formRules" ref="formd">
        <el-form-item label="昵称" prop="nick">
          <el-input v-model="formData.nick" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input type="textarea" v-model="formData.desc" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="formData.phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系微信">
          <el-input v-model="formData.wxname" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <!--工具条-->
    <div slot="footer" class="dialog-footer">
      <el-button @click.native="formVisible = false">取消</el-button>
      <el-button type="primary" @click.native="formSubmit" :loading="formLoading">确认</el-button>
    </div>
  </el-dialog>
</template>


<script>
import { mapGetters } from 'vuex'
const regPhone = /^([0-9]{0,3})[1][3,4,5,7,8,9][0-9]{9}$/;
export default {
  data () {
    return {
      formVisible: false,
      formLoading: false,
      formRules: {
        nick: [
          { required: true, message: '请输入参数' }
        ], phone: [
          // { required: true, message: '请输入参数' },
          {
            validator: (rule, value, callback) => {
              // console.log('test:',value,regPhone.test(value));
              if (!value||value == '' || regPhone.test(value))
                callback();
              else
                callback(new Error('格式错误：必须是 "手机号"'));
            }
          }
        ]
      },
      //新增界面数据
      formData: {}
    }
  },
  computed: {
    // 使用对象展开运算符将 getters 混入 computed 对象中
    ...mapGetters([
      'getUserInfo'
    ])
  },
  methods: {
    show () {
      this.formVisible = true;
      this.formData = {
        nick: this.getUserInfo.nick,
        desc: this.getUserInfo.desc,
        phone: this.getUserInfo.lxphone,
        wxname: this.getUserInfo.wxname,
      }
    },/*handleSelect:function(id){
                this.tmpltCont='';
                if(id==''){
                    return
                }
                let it=this.tmplatdatas[id];
                if(it==null){
                    return
                }
                //console.log("123",this.tmplatdatas[id]);
                this.tmpltCont=it.Content;
                this.tmpltmapls=[];
                SmsTmpltKeys(id).then(res=>{
                    for(let i in res.data){
                        this.tmpltmapls.push({
                            key:res.data[i],value:''
                        });
                    }
                });
			},*/formSubmit () {
      this.$refs.formd.validate((valid) => {
        if (valid) {
          this.formLoading = true;
          this.$post('/user/upinfo', this.formData).then(res => {
            console.log(res);
            this.$emit('submitOK');
            this.formLoading = false;
            this.formVisible = false;
            //this.$message('操作成功');
            window.top.location.reload();
          }).catch(err => {
            this.$emit('submitErr', err);
            this.formLoading = false;
            //this.formVisible = false;
            this.$message({
              message: err.response ? err.response.data || '服务器错误' : '网络错误',
              type: 'error'
            });
          });
        }
      });
    }
  }
};

</script>

<style scoped>
.tmpdesc {
  margin-left: 10px;
  color: #d0d0d0;
}
</style>




// WEBPACK FOOTER //
// proEdit.vue?19c7a3a3